import { Icon } from '@examdojo/core/icon';

/**
 * Where a nav item renders. The two surfaces are separate components (a desktop
 * rail and a mobile bottom bar), not one reflowing layout, so the item *set*
 * differs and not just its order — `Ask Sensei` is desktop-only, and `Profile`
 * is promoted from the desktop's footer link into a mobile tab. Declaring the
 * surfaces on the item is what keeps the two from drifting apart.
 */
export type SidenavSurface = 'desktop' | 'mobile';

export interface SidenavItem {
  route: string;
  labelKey: string;
  labelKeyMobile?: string;
  /**
   * A shorter label for a tab on a phone, where five of them share the width.
   * Separate from `labelKeyMobile`, which a tablet reads too: the student's
   * native bar is the only surface narrow enough to need it.
   */
  labelKeyPhone?: string;
  icon: Icon;
  /** Surfaces this item appears on. Omitted means both. */
  surfaces?: readonly SidenavSurface[];
}

export const rendersOn = (item: SidenavItem, surface: SidenavSurface): boolean =>
  !item.surfaces || item.surfaces.includes(surface);
